var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IQOSModal',[_c('div',{staticClass:"busy-container"},[_c('img',{attrs:{"src":"/icons/busy-panda.svg"}}),_c('h1',[_vm._v(_vm._s(_vm.$t('busy_modal.title')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }